import { html, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';

import { litStyles as buttonStyles } from 'portal-base/src/base/css/ki-button-styles.css';

import { KiDsPwaComponent } from '../../base/ki-ds-pwa-component';
import { skeletonStyles } from '../../styles/skeleton.css';
import styles from './ki-ds-pwa-timeseries-list.css';
import '../ki-ds-pwa-timeseries-location-group/ki-ds-pwa-timeseries-location-group';

const CLASS_NAME = 'ki-ds-pwa-timeseries-list';

@customElement(CLASS_NAME)
export class KiDsPwaTimeseriesList extends KiDsPwaComponent {
    static styles = [buttonStyles, styles, skeletonStyles];

    static get properties() {
        return {
            timeseriesByLocation: { type: Object },
            selectedIds: { type: Array },
            selectable: { type: Boolean },
            alarmStatusList: { type: Array },
            alarmConfigs: { type: Array },
            classificationTemplate: { type: Object },
            parameters: { type: Object },
            isLoading: { type: Boolean },
        };
    }

    constructor() {
        super();
        this.timeseriesByLocation = {};
        this.selectedIds = [];
        this.selectable = true;
        this.alarmStatusList = [];
        this.alarmConfigs = [];
        this.classificationTemplate = null;
        this.parameters = null;
        this.isLoading = false;
    }

    render() {
        if (this.isLoading) {
            return this._renderSkeleton();
        }

        return html`
            <div class="list">
                ${this.selectedIds.length > 1
                ? html`
                          <div class="selection-bar">
                              <span>${this.selectedIds.length} selected</span>
                              <button class="secondary small" @click=${this.__onClearSelection}>
                                  <i class="fa-sharp fa-solid fa-times"></i>
                                  Clear
                              </button>
                          </div>
                      `
                : nothing}
                ${this._sortedGroups.map(
                    ({ location, tsList, offset }) => html`
                            <ki-ds-pwa-timeseries-location-group
                                .location=${location}
                                .timeseries=${tsList}
                                .staggerOffset=${offset}
                                .selectedIds=${this.selectedIds}
                                .selectable=${this.selectable}
                                .alarmStatusList=${this.alarmStatusList}
                                .alarmConfigs=${this.alarmConfigs}
                                .classificationTemplate=${this.classificationTemplate}
                                .parameters=${this.parameters}
                            ></ki-ds-pwa-timeseries-location-group>
                        `,
                )}
            </div>
        `;
    }



    __onClearSelection() {
        this.dispatchEvent(new CustomEvent('clear-selection', { bubbles: true, composed: true }));
    }

    get _sortedGroups() {
        const entries = Object.entries(this.timeseriesByLocation || {});
        entries.sort(([a], [b]) => a.localeCompare(b));

        let offset = 0;
        return entries.map(([location, tsList]) => {
            const group = { location, tsList, offset };
            offset += tsList.length;
            return group;
        });
    }

    _renderSkeleton() {
        const group = (count) => html`
            <div class="skeleton-group">
                <div class="skeleton-location skeleton skeleton-block"></div>
                ${Array.from(
            { length: count },
            () => html`
                        <div class="skeleton-entry skeleton">
                            <div class="skeleton-icon skeleton-circle skeleton-block"></div>
                            <div class="skeleton-body">
                                <div class="skeleton-name skeleton-block"></div>
                                <div class="skeleton-meta">
                                    <div class="skeleton-block"></div>
                                    <div class="skeleton-block"></div>
                                </div>
                            </div>
                        </div>
                    `,
        )}
            </div>
        `;

        return html`<div class="list">
            <div class="skeleton-container">${group(3)}${group(3)}</div>
        </div>`;
    }
}
